<template>
    <div class="auto-applied-coupon" role="status">
        <span class="auto-applied-coupon__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M3.00391 6.99932L11.4492 1.36912C11.7851 1.14519 12.2227 1.14519 12.5586 1.36912L21.0039 6.99932V20.9993C21.0039 21.5516 20.5562 21.9993 20.0039 21.9993H4.00391C3.45163 21.9993 3.00391 21.5516 3.00391 20.9993V6.99932ZM5.00391 8.06969V19.9993H19.0039V8.06969L12.0039 3.40302L5.00391 8.06969ZM12.0039 10.9993C10.8993 10.9993 10.0039 10.1039 10.0039 8.99932C10.0039 7.89475 10.8993 6.99932 12.0039 6.99932C13.1085 6.99932 14.0039 7.89475 14.0039 8.99932C14.0039 10.1039 13.1085 10.9993 12.0039 10.9993Z"
                    fill="#85C42C"
                />
            </svg>
        </span>
        <div>
            <div>{{ couponCode }} applied</div>
            <div v-if="discount">-{{ discount }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        couponCode: {
            type: String,
            required: true,
        },
        discount: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss">
.auto-applied-coupon {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #85c42c;
    border-radius: 8px;
    background: rgba(133, 196, 44, 0.1);
    color: #1f2529;
    font-size: 16px;
    line-height: 1.5;
    &__icon {
        flex: 0 0 24px;
        font-size: 0;
    }
}
</style>
